module.exports = __webpack_public_path__ + "static/media/login-charts.3e8de269.svg";